import { render, staticRenderFns } from "./ShippedArticlesStore.vue?vue&type=template&id=57d2403a&scoped=true"
import script from "./ShippedArticlesStore.vue?vue&type=script&lang=js"
export * from "./ShippedArticlesStore.vue?vue&type=script&lang=js"
import style0 from "./ShippedArticlesStore.vue?vue&type=style&index=0&id=57d2403a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2403a",
  null
  
)

export default component.exports